import React from 'react';
import propTypes from 'prop-types';
import { getDiscountPrice } from '../../utilites';

export default function Price({ status, price }) {
  const { dictionary } = startup;
  const discountPrice = getDiscountPrice(price);
  return (
    <div className="b-goods-f__sidebar">
      {/* <a className="b-goods-f__bnr" href=""><img src="../media/content/b-goods/auto-check.png" alt="auto check" /></a> */}
      <span className="b-goods-f__price-group">
        <span className="b-goods-f__price">
          <span className="b-goods-f__price_col">
            {status === 'Sold' ? '' : `${dictionary.Price}`}
          </span>
          <span className="b-goods-f__price-numb">
            {status === 'Sold' ? '' : ` €`}
            {status === 'Sold' ? '' : price}
          </span>
          {/*<span className="b-goods-f__price-numb price">
            {status === 'Sold' ? '' : ` € `}
            <s>
            {status === 'Sold' ? '' : price}
            </s>
          </span>
          <span className="b-goods-f__price-numb discount-price">
            {status === 'Sold' ? '' : ` ${discountPrice}`}
          </span> */}
        </span>
      </span>
    </div>
  );
}

Price.propTypes = {
  status: propTypes.string.isRequired,
  price: propTypes.number.isRequired,
};
